import type { ProLayoutProps } from "@ant-design/pro-components";

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
} = {
  navTheme: "light",
  colorPrimary: "#3C7AFF",
  layout: "top",
  contentWidth: "Fluid",
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: "劳务班组实名制管理系统",
  pwa: true,
  // logo: "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg",
  logo: "/logo.svg",
  iconfontUrl: "",
  // siderWidth: 200,
  breadcrumbRender: false, // 禁用面包屑
  token: {
    bgLayout: "#F2F1F6",
    header: {
      colorBgHeader: "#000",
      colorHeaderTitle: "#fff",
      colorTextMenu: "#999999",
      colorTextMenuSelected: "#fff",
      colorBgMenuItemSelected: "transparent",
      colorBgMenuItemHover: "transparent",
      colorTextMenuActive: "#fff",
    },
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
